// extracted by mini-css-extract-plugin
export default {"container":"errorInfo_container__J4Buz","info":"errorInfo_info__BE0Ww"};